import { compile, PathFunction } from 'path-to-regexp';
import qs from 'qs';

export type CompilePathParams = {
  [key: string]: string | number | string[] | number[];
};
export type CompilePathQuery = {
  [key: string]: any;
};

// Internal type that matches path-to-regexp constraints
type PathToRegexpParams = {
  [key: string]: string | string[];
};

type CompilePathCache = {
  [key: string]: PathFunction<PathToRegexpParams>;
};

const compilePathCache: CompilePathCache = {};

export function compilePath(
  pattern: string,
  params?: CompilePathParams,
  query?: CompilePathQuery
): string {
  if (!compilePathCache[pattern]) {
    compilePathCache[pattern] = compile(pattern);
  }

  // Convert params to match path-to-regexp constraints
  const convertedParams: PathToRegexpParams | undefined = params
    ? {
        ...Object.fromEntries(
          Object.entries(params).map(([key, value]) => [
            key,
            Array.isArray(value) ? value.map((v) => String(v)) : String(value),
          ])
        ),
      }
    : undefined;

  const compiledPath = compilePathCache[pattern](convertedParams);
  const compiledQuery = query ? qs.stringify(query, { encode: false }) : null;
  let decodedPath;
  let decodedQuery;

  try {
    decodedPath = decodeURI(compiledPath);
    decodedQuery = compiledQuery ? decodeURIComponent(compiledQuery) : null;
  } catch {
    throw new URIError(
      `Pathname "${
        compiledQuery ? `${compiledPath}?${compiledQuery}` : compiledPath
      }" could not be decoded. ` + `This is likely caused by an invalid percent-encoding.`
    );
  }
  return decodedQuery ? `${decodedPath}?${decodedQuery}` : decodedPath;
}
